/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_gc_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What input can I paste?`)
};

const es_gc_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Qué entrada puedo pegar?`)
};

const de_gc_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Welche Eingabe kann ich einfügen?`)
};

const nl_gc_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Welke invoer kan ik plakken?`)
};

const fr_gc_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quelle entrée puis-je coller ?`)
};

const it_gc_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Che input posso incollare?`)
};

const pt_br2_gc_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Que tipo de entrada posso colar?`)
};

const pt_gc_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Que entrada posso colar?`)
};

const ja_gc_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`どんな入力を貼り付けられますか？`)
};

const zh_gc_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`可以粘贴什么样的输入？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const gc_faq_q4 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.gc_faq_q4(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("gc_faq_q4", locale)
	if (locale === "en") return en_gc_faq_q4(inputs)
	if (locale === "es") return es_gc_faq_q4(inputs)
	if (locale === "de") return de_gc_faq_q4(inputs)
	if (locale === "nl") return nl_gc_faq_q4(inputs)
	if (locale === "fr") return fr_gc_faq_q4(inputs)
	if (locale === "it") return it_gc_faq_q4(inputs)
	if (locale === "pt-BR") return pt_br2_gc_faq_q4(inputs)
	if (locale === "pt") return pt_gc_faq_q4(inputs)
	if (locale === "ja") return ja_gc_faq_q4(inputs)
	return zh_gc_faq_q4(inputs)
};